import type { Bill } from '@/types/bill'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { BillImpactSections } from "./BillImpactSections"

interface BillImpactDialogProps {
  bill: Bill | null
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function BillImpactDialog({ bill, open, onOpenChange }: BillImpactDialogProps) {
  if (!bill?.monitor_analysis) return null
  
  // Get the dialog title from the monitor_analysis data (now a data field) or use default
  const getDialogTitle = () => {
    const analysisTitle = bill.monitor_analysis?.title
    const baseTitle = analysisTitle || "Impact Analysis"
    return `${baseTitle}: ${bill.bill_number}`
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl p-3">
        <DialogHeader className="pb-1 mb-0">
          <DialogTitle>{getDialogTitle()}</DialogTitle>
        </DialogHeader>

        <div className="py-1">
          <BillImpactSections bill={bill} />
        </div>
      </DialogContent>
    </Dialog>
  )
}